import React from 'react';


const CreateCitations = () => {
     return (
          <div className='mt-4'>
               <h3 className='text-center'>Create Citations</h3>
               <div className='text-center fw-bold'>To Create Citations, You will need to do a search using the Search Now Button. This will give you a list of Citations that are available.</div>
               <div className='text-center'>You can then select the Citations you want to create and click on the Create Citations Button.</div>
          </div>
     );
};

export default CreateCitations;